import { Link } from "react-router-dom";
import noticias from "../data/noticias";

// Función auxiliar para convertir fecha en string a Date
const parseFecha = (fechaStr) => {
  // Reemplazamos los meses en español a inglés para que Date los entienda
  const meses = {
    enero: "January",
    febrero: "February",
    marzo: "March",
    abril: "April",
    mayo: "May",
    junio: "June",
    julio: "July",
    agosto: "August",
    septiembre: "September",
    octubre: "October",
    noviembre: "November",
    diciembre: "December",
  };

  const fechaNormalizada = fechaStr.toLowerCase().replace(
    /(\d{1,2}) (\w+) (\d{4})/,
    (_, dia, mes, año) => `${dia} ${meses[mes] || mes} ${año}`
  );

  return new Date(fechaNormalizada);
};

const NoticiasGrid = () => {
  const ultimas = [...noticias]
    .sort((a, b) => parseFecha(b.fecha) - parseFecha(a.fecha))
    .slice(0, 3); // solo las 3 más recientes

  return (
    <section className="py-10 bg-[#202C5A]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold mb-8 text-left uppercase text-white border-b-2 border-white pb-2">
          Últimas Noticias
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          {ultimas.map((nota) => (
            <Link
              key={nota.id}
              to={`/noticias/${nota.id}`}
              className="relative aspect-[4/5] overflow-hidden group rounded shadow-lg transition-transform hover:scale-105"
            >
              <img
                src={nota.imagen}
                alt={nota.titulo}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div
                className="absolute left-1/2 w-full px-2 z-10 flex flex-col items-center"
                style={{ top: "62%", transform: "translate(-50%, 0)" }}
              >
               <div
  className="w-full flex flex-col items-center px-4 py-3"
  style={{ background: "rgba(13,40,120,0.5)" }}  // Opacidad aumentada a 0.5
>

                  <div className="flex items-center gap-2 mb-2">
                    <span className="bg-[#FF69B4] text-white text-xs px-2 py-1 uppercase">
                      {nota.categoria}
                    </span>
                    <span className="text-white text-xs">{nota.fecha}</span>
                  </div>
                  <h3 className="text-white text-center font-bold uppercase text-2xl md:text-3xl tracking-tight leading-tight">
                    {nota.titulo}
                  </h3>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-right mt-8">
          <Link
            to="/noticias"
            className="inline-flex items-center text-white font-medium hover:text-[#FF69B4] transition border-b border-white pb-1"
          >
            Ver todas las noticias
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 ml-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NoticiasGrid;
